<template>
  <div v-if="tabs.length > 0 && defaultTab.name !== undefined" class="vertical-tabs-container">
    <div class="vertical-tabs">
      <div
        v-for="(tab, i) in filteredTabs"
        :key="i"
        class="vertical-tab pa-4"
        :class="{ 'vertical-tab-active': tab === activeTab }"
        @click="switchTab(tab)"
      >
        {{ tab.name }}
      </div>
      <div class="pa-2">
        <slot name="after-tabs" />
      </div>
    </div>
    <div class="vertical-tabs-contents pa-3">
      <Transition :name="transitionName" mode="out-in" appear>
        <div :key="tabs.indexOf(activeTab)" class="vertical-tabs-content">
          <slot :name="activeTab.name" />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerticalTabs',
  props: {
    tabs: {
      name: 'tabs',
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: '',
      transitionName: 'slide-down',
    }
  },
  computed: {
    defaultTab() {
      const tab = this.tabs.find(tab => tab.default === true)
      if (tab === undefined) return {}
      return tab
    },
    filteredTabs() {
      return this.tabs.filter(tab => tab.condition === undefined || tab.condition === true)
    },
  },
  created() {
    this.activeTab = this.defaultTab
  },
  methods: {
    switchTab(tab) {
      if (tab === this.activeTab) return
      const activeTabIndex = this.tabs.indexOf(this.activeTab)
      const tabIndex = this.tabs.indexOf(tab)
      this.transitionName = activeTabIndex > tabIndex ? 'slide-up' : 'slide-down'
      this.activeTab = tab
    },
  },
}
</script>

<style lang="postcss" scoped>
.vertical-tabs-container {
  width: 100%;
  display: flex;

  & .vertical-tabs {
    min-width: 200px;

    & .vertical-tab {
      font-family: var(--font-stylized);
      font-size: 16px;
      cursor: pointer;

      &:hover {
        background-color: var(--base);
      }
    }

    & .vertical-tab-active {
      background-color: var(--base);
      border-left: 3px solid var(--primary) !important;
    }
  }

  & .vertical-tabs-contents {
    width: 100%;
    font-size: 16px;
    background-color: var(--base);
  }
}
</style>
